import { Component, Input, OnInit } from '@angular/core';
import { ModalController, AlertController, ActionSheetController, ToastController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { JavapiService } from '../../services/javapi.service';
import { MetodosgenService } from '../../services/metodosgen.service';
import { CotizacioneseditComponent } from '../cotizacionesedit/cotizacionesedit.component';
import { ComentariosComponent } from '../comentarios/comentarios.component';
import { TrabajosmenuComponent } from '../trabajosmenu/trabajosmenu.component';
import { TrabajoslistComponent } from '../trabajoslist/trabajoslist.component';
import { TrabajoseditComponent } from '../trabajosedit/trabajosedit.component';
import { SeguimientoComponent } from '../seguimiento/seguimiento.component';
import { InspeccionareaComponent } from '../inspeccionarea/inspeccionarea.component';
import { InspeccioneslistComponent } from '../inspeccioneslist/inspeccioneslist.component';
import { EnviarcorreoComponent } from '../enviarcorreo/enviarcorreo.component';
import { Browser } from '@capacitor/browser';
import { Share } from '@capacitor/share';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Metodosui } from '../../services/metodosui';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'app-cotizacionesmenu',
    templateUrl: './cotizacionesmenu.component.html',
    styleUrls: ['./cotizacionesmenu.component.scss'],
    standalone: false
})
export class CotizacionesmenuComponent implements OnInit {

    @Input() cotizacion: any;
    @Input() trabajo: any;

    estadosCotizacion: string[] = [
        'Borrador', 'Enviada', 'En Revision', 'Esperando Datos', 'Corregir', 'Aprobada', 'Rechazada', 'Cancelada'
    ];

    permissions: any = {};
    billingInfo: any = null;
    isWeb: boolean = false;

    constructor(
        private modalCtrl: ModalController,
        private alertCtrl: AlertController,
        private actionSheetCtrl: ActionSheetController,
        private toastCtrl: ToastController,
        private javapiService: JavapiService,
        private metodosGenService: MetodosgenService,
        private metodosUi: Metodosui
    ) { }

    ngOnInit() {
        this.permissions = this.metodosGenService.getPermissions();
        this.loadBillingInfo();
        this.checkLinkedInspeccion();
        this.isWeb = !Capacitor.isNativePlatform();
    }

    close() {
        this.modalCtrl.dismiss();
    }

    // ── Edit ───────────────────────────
    async edit() {
        // Parent handles the actual editing via dismiss data
        this.modalCtrl.dismiss({ action: 'edit', cotizacion: this.cotizacion });
    }

    // ── Clone ──────────────────────────
    async clone() {
        this.modalCtrl.dismiss({ action: 'clone', cotizacion: this.cotizacion });
    }

    // ── Delete ─────────────────────────
    async confirmDelete() {
        this.modalCtrl.dismiss({ action: 'delete', cotizacion: this.cotizacion });
    }

    // ── Comments ───────────────────────
    async openComments() {
        const modal = await this.modalCtrl.create({
            component: ComentariosComponent,
            componentProps: {
                modulo: 'COTIZACIONES',
                referencia_id: this.cotizacion.id,
                titulo_referencia: `Cotización #${this.cotizacion.id}`
            }
        });
        await modal.present();
    }

    // ── PDF ────────────────────────────
    async viewPdf() {
        const url = this.javapiService.getFileUrl('COT', this.cotizacion.id, false);
        await Browser.open({ url });
    }

    async downloadPdf() {
        await this.metodosUi.showLoading('Descargando PDF...', 'blue');
        try {
            const url = this.javapiService.getFileUrl('COT', this.cotizacion.id, false);
            const response = await fetch(url);
            if (!response.ok) throw new Error('Error al descargar');
            const blob = await response.blob();
            const blobUrl = URL.createObjectURL(blob);

            let prefijo = 'PG-COT_';
            try {
                const paramRes = await firstValueFrom(this.javapiService.getJsonParam('CT_ARCHIVOS'));
                if (paramRes && paramRes.pa_json) {
                    const config = JSON.parse(paramRes.pa_json);
                    prefijo = config.COTIZACION || 'PG-COT_';
                }
            } catch (err) {}

            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = `${prefijo}${this.cotizacion.id}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
            await this.metodosUi.hideLoading();
            this.metodosUi.showToast('Descarga iniciada', 'success');
        } catch (e) {
            await this.metodosUi.hideLoading();
            const url = this.javapiService.getFileUrl('COT', this.cotizacion.id, true);
            await Browser.open({ url });
        }
    }

    // ── Compartir PDF ──────────────────
    async sharePdf() {
        await this.metodosUi.showLoading('Preparando PDF para compartir...', 'blue');
        try {
            const url = this.javapiService.getFileUrl('COT', this.cotizacion.id, false);
            const response = await fetch(url);
            if (!response.ok) throw new Error('Error al descargar el archivo');
            const blob = await response.blob();

            let prefijo = 'PG-COT_';
            try {
                const paramRes = await firstValueFrom(this.javapiService.getJsonParam('CT_ARCHIVOS'));
                if (paramRes && paramRes.pa_json) {
                    const config = JSON.parse(paramRes.pa_json);
                    prefijo = config.COTIZACION || 'PG-COT_';
                }
            } catch (err) {}

            // Convertir Blob a Base64 para guardarlo nativamente
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = async () => {
                try {
                    const base64data = reader.result as string;
                    const base64Raw = base64data.split(',')[1];

                    const fileName = `${prefijo}${this.cotizacion.id}.pdf`;
                    
                    // Guardar en la caché nativa del móvil
                    const savedFile = await Filesystem.writeFile({
                        path: fileName,
                        data: base64Raw,
                        directory: Directory.Cache
                    });

                    await this.metodosUi.hideLoading();

                    // Compartir archivo nativo real (WhatsApp, Gmail, Drive, etc.)
                    await Share.share({
                        title: `Cotización #${this.cotizacion.id}`,
                        url: savedFile.uri
                    });
                } catch (innerErr) {
                    console.error('Error en proceso nativo de compartir:', innerErr);
                    await this.metodosUi.hideLoading();
                    // Fallback a apertura en navegador externo
                    await Browser.open({ url });
                }
            };
        } catch (e: any) {
            await this.metodosUi.hideLoading();
            console.error('Error al descargar para compartir:', e);
            try {
                const url = this.javapiService.getFileUrl('COT', this.cotizacion.id, false);
                await Browser.open({ url });
            } catch (err) {}
        }
    }

    // ── Enviar Correo ───────────────────
    async abrirEnviarCorreo(): Promise<void> {
        const modal = await this.modalCtrl.create({
            component: EnviarcorreoComponent,
            componentProps: {
                tituloModal: `Enviar Cotización #${this.cotizacion.id}`,
                moduloOrigen: 'COTIZACIONES',
                idReferencia: this.cotizacion.id,
                dataSource: this.cotizacion,
                asuntoPrellenado: `Cotización #${this.cotizacion.id} - ${this.cotizacion.cliente || ''}`
            },
            cssClass: 'fullscreen-modal'
        });
        await modal.present();

        const { data } = await modal.onDidDismiss();
        if (data?.exito && (data?.accion === 'ENVIADO' || data?.accion === 'ENVIAR')) {
            // Si se envió exitosamente y el estado NO es Aprobada, actualizar estado a 'Enviada'
            if ((this.cotizacion.estado || '').toLowerCase() !== 'aprobada') {
                await this.executeStatusChange('Enviada', 'Correo enviado desde la app');
            }
        }
    }

    async openSeguimiento() {
        const modal = await this.modalCtrl.create({
            component: SeguimientoComponent,
            componentProps: { 
                cotizacion: this.cotizacion,
                trabajo: this.trabajo,
                billingInfo: this.billingInfo
            }
        });
        await modal.present();
    }

    // ── Status Change ──────────────────
    async changeStatus() {
        const currentEstado = (this.cotizacion?.estado || '').toLowerCase();
        let availableEstados = [...this.estadosCotizacion];

        // Restricciones de estado (SUPERADMIN se salta estas reglas)
        if (!this.metodosGenService.isSuperAdmin()) {
            if (currentEstado === 'enviada') {
                availableEstados = ['Aprobada'];
            } else if (currentEstado === 'aprobada') {
                availableEstados = ['Cancelada'];
            }
        }

        const buttons = availableEstados
            .filter(estado => estado !== this.cotizacion.estado) // Evitar mostrar el estado actual
            .map(estado => {
                let icon = 'ellipse-outline';
                let cssClass = 'action-sheet-default';
                const e = (estado || '').toLowerCase();

                if (e === 'aprobada') { icon = 'checkmark-circle'; cssClass = 'action-sheet-success'; }
                else if (e === 'borrador') { icon = 'document'; cssClass = 'action-sheet-gray'; }
                else if (e === 'enviada') { icon = 'send'; cssClass = 'action-sheet-blue'; }
                else if (e === 'rechazada' || e === 'cancelada') { icon = 'close-circle'; cssClass = 'action-sheet-danger'; }
                else if (e === 'en revision' || e === 'esperando datos') { icon = 'time'; cssClass = 'action-sheet-warning'; }
                else if (e === 'corregir') { icon = 'alert-circle'; cssClass = 'action-sheet-warning'; }

                return {
                    text: estado,
                    icon: icon,
                    cssClass: cssClass,
                    handler: () => {
                        if (e === 'aprobada' || e === 'enviada') {
                            this.executeStatusChange(estado, '');
                        } else {
                            this.askStatusComment(estado);
                        }
                    }
                };
            });

        buttons.push({
            text: 'Cancelar',
            icon: 'close',
            role: 'cancel',
            cssClass: 'action-sheet-cancel',
            handler: () => { }
        } as any);

        const actionSheet = await this.actionSheetCtrl.create({
            header: 'Actualizar Estado a:',
            buttons: buttons,
            cssClass: 'custom-action-sheet'
        });

        await actionSheet.present();
    }

    async askStatusComment(nuevoEstado: string) {
        const alert = await this.alertCtrl.create({
            header: 'Motivo del cambio de estado',
            subHeader: 'Dejar un comentario para el registro',
            cssClass: 'custom-alert',
            inputs: [
                {
                    name: 'comentario',
                    type: 'textarea',
                    placeholder: 'Escribe un comentario o justificación...',
                    cssClass: 'custom-textarea'
                }
            ],
            buttons: [
                {
                    text: 'Omitir y Cambiar',
                    role: 'cancel',
                    cssClass: 'alert-button btn-cancel',
                    handler: async () => {
                        await this.executeStatusChange(nuevoEstado, '');
                    }
                },
                {
                    text: 'Guardar',
                    cssClass: 'alert-button btn-save',
                    handler: async (data) => {
                        let comentarioStr = data.comentario ? data.comentario.trim() : '';
                        await this.executeStatusChange(nuevoEstado, comentarioStr);
                    }
                }
            ]
        });
        await alert.present();
    }

    private async executeStatusChange(nuevoEstado: string, comentario: string) {
        try {
            const userJson = localStorage.getItem('user');
            let usuario = '';
            if (userJson) {
                const user = JSON.parse(userJson);
                usuario = user.l_usuario || '';
            }

            const payload = this.metodosGenService.setModeloGeneral(
                "cotizaciones", "cotizacionStatusUpdate",
                String(this.cotizacion.id),
                nuevoEstado,
                comentario,
                usuario,
                '', '', '', '', '', '', '', '', '', '', ''
            );

            const res: any = await firstValueFrom(this.javapiService.getCommonModel(payload));
            if (res) {
                this.cotizacion.estado = nuevoEstado;
            }
        } catch (e) {
            console.error('Error updating status:', e);
        }
    }

    // ── Link / Unlink ──────────────────
    async unlinkFromTrabajo() {
        if (!this.cotizacion?.trabajoId || this.cotizacion.trabajoId === '0') return;

        const alert = await this.alertCtrl.create({
            header: 'Desvincular',
            message: `¿Estás seguro de desvincular esta cotización del trabajo #${this.cotizacion.trabajoId}?`,
            buttons: [
                { text: 'Cancelar', role: 'cancel' },
                {
                    text: 'Desvincular',
                    role: 'destructive',
                    handler: async () => {
                        try {
                            const usuario = this.metodosGenService.getUsuario();
                            const payload = this.metodosGenService.setModeloGeneral(
                                'cotizaciones', 'unlinkCotizacionTrabajo',
                                String(this.cotizacion.id),
                                '', usuario, '', '', '', '', '', '', '', '', '', '', '', ''
                            );
                            await firstValueFrom(this.javapiService.getCommonModel(payload));
                            
                            const toast = await this.toastCtrl.create({
                                message: 'Cotización desvinculada del trabajo correctamente',
                                duration: 2000,
                                color: 'success'
                            });
                            await toast.present();
                            
                            this.cotizacion.trabajoId = '0';
                            this.modalCtrl.dismiss({ action: 'unlinked' });
                        } catch (e) {
                            console.error('Error unlinking trabajo:', e);
                        }
                    }
                }
            ]
        });
        await alert.present();
    }

    async unlinkFromInspeccion() {
        if (!this.cotizacion?.inspeccionId || this.cotizacion.inspeccionId === '0') return;

        const alert = await this.alertCtrl.create({
            header: 'Desvincular',
            message: `¿Estás seguro de desvincular esta cotización de la inspección/solicitud #${this.cotizacion.inspeccionId}?`,
            buttons: [
                { text: 'Cancelar', role: 'cancel' },
                {
                    text: 'Desvincular',
                    role: 'destructive',
                    handler: async () => {
                        try {
                            const usuario = this.metodosGenService.getUsuario();
                            const payload = this.metodosGenService.setModeloGeneral(
                                'cotizaciones', 'unlinkInspeccionCotizacion',
                                String(this.cotizacion.id),
                                '', usuario, '', '', '', '', '', '', '', '', '', '', '', ''
                            );
                            await firstValueFrom(this.javapiService.getCommonModel(payload));

                            const toast = await this.toastCtrl.create({
                                message: 'Cotización desvinculada de la inspección correctamente',
                                duration: 2000,
                                color: 'success'
                            });
                            await toast.present();

                            this.cotizacion.inspeccionId = '0';
                            this.modalCtrl.dismiss({ action: 'unlinked' });
                        } catch (e) {
                            console.error('Error unlinking inspeccion:', e);
                        }
                    }
                }
            ]
        });
        await alert.present();
    }

    // ── Helpers ────────────────────────
    getEstadoColor(): any {
        const e = (this.cotizacion?.estado || '').toLowerCase();
        if (e === 'aprobada') return { background: 'rgba(39, 174, 96, 0.12)', color: '#27ae60' };
        if (e === 'enviada') return { background: 'rgba(52, 152, 219, 0.12)', color: '#2980b9' };
        if (e === 'en revision' || e === 'esperando datos') return { background: 'rgba(243, 156, 18, 0.12)', color: '#f39c12' };
        if (e === 'corregir') return { background: 'rgba(230, 126, 34, 0.12)', color: '#e67e22' };
        if (e === 'rechazada' || e === 'cancelada') return { background: 'rgba(231, 76, 60, 0.12)', color: '#e74c3c' };
        return { background: 'rgba(149, 165, 166, 0.12)', color: '#7f8c8d' }; // Borrador / default
    }

    // ── Navigate to Trabajo ──────────────
    async goToTrabajo() {
        if (this.cotizacion?.trabajoId && this.cotizacion.trabajoId !== '0') {
            try {
                // Load trabajo data from backend
                const data: any = await firstValueFrom(
                    this.javapiService.getCommonModel(
                        this.metodosGenService.setModeloGeneral(
                            'genModel', 'trabajos', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''
                        )
                    )
                );
                if (Array.isArray(data)) {
                    const found = data.find((item: any) => Number(item.dt1) === Number(this.cotizacion.trabajoId));
                    if (found) {
                        const trabajo = {
                            id: Number(found.dt1) || 0,
                            cliente: found.dt2 ?? '',
                            lugar: found.dt3 ?? '',
                            descripcion: found.dt4 ?? '',
                            solicitante: found.dt5 ?? '',
                            incluye_material: found.dt6 ?? 'Y',
                            estado: found.dt7 ?? '',
                            fecha_creacion: found.dt8 ?? ''
                        };
                        const modal = await this.modalCtrl.create({
                            component: TrabajosmenuComponent,
                            componentProps: { trabajo }
                        });
                        await modal.present();
                    }
                }
            } catch (e) {
                console.error('Error loading trabajo:', e);
            }
        } else {
            // No trabajo linked, show options
            this.addTrabajoFromMenu();
        }
    }

    // ── Navigate to Inspección ────────────
    async goToInspeccion() {
        if (this.cotizacion?.inspeccionId && this.cotizacion.inspeccionId !== '0') {
            try {
                const res: any = await firstValueFrom(
                    this.javapiService.getCommonModel(
                        this.metodosGenService.setModeloGeneral(
                            'genModel', 'inspeccionGetOne', String(this.cotizacion.inspeccionId), '', '', '', '', '', '', '', '', '', '', '', '', '', ''
                        )
                    )
                );
                
                if (Array.isArray(res) && res.length > 0) {
                    const row = res[0];
                    const inspeccion = {
                        id: Number(row.dt1),
                        cliente: row.dt2,
                        direccion: row.dt3,
                        descripcion: row.dt4,
                        solicitante: row.dt5,
                        estado: row.dt6,
                        fecha_creacion: row.dt7,
                        cliente_id: Number(row.dt8),
                        direccion_id: Number(row.dt9),
                        solicitante_id: Number(row.dt10)
                    };
                    
                    const modal = await this.modalCtrl.create({
                        component: InspeccionareaComponent,
                        componentProps: { inspeccion }
                    });
                    await modal.present();
                }
            } catch (e) {
                console.error('Error loading inspeccion:', e);
            }
        } else {
            // Sin inspección vinculada, mostrar opciones
            this.addInspeccionFromMenu();
        }
    }

    async addInspeccionFromMenu() {
        const actionSheet = await this.actionSheetCtrl.create({
            header: 'Opciones de Inspección / Solicitud',
            subHeader: `Para cotización #${this.cotizacion.id}`,
            buttons: [
                {
                    text: 'Vincular Inspección Existente',
                    icon: 'link-outline',
                    handler: () => { this.linkExistingInspeccion(); }
                },
                {
                    text: 'Cancelar',
                    icon: 'close',
                    role: 'cancel'
                }
            ],
            cssClass: 'custom-action-sheet'
        });
        await actionSheet.present();
    }

    async linkExistingInspeccion() {
        const modal = await this.modalCtrl.create({
            component: InspeccioneslistComponent,
            componentProps: {
                selectionMode: true,
                cotizacion: this.cotizacion
            }
        });
        await modal.present();

        const { data } = await modal.onDidDismiss();
        if (data && data.selectedInspeccion) {
            await this.confirmLinkInspeccion(data.selectedInspeccion);
        }
    }

    async confirmLinkInspeccion(inspeccion: any) {
        try {
            const usuario = this.metodosGenService.getUsuario();
            const payload = this.metodosGenService.setModeloGeneral(
                "cotizaciones", "linkInspeccionCotizacion",
                String(inspeccion.id),
                String(this.cotizacion.id),
                usuario, '', '', '', '', '', '', '', '', '', '', '', ''
            );

            const res: any = await firstValueFrom(this.javapiService.getCommonModel(payload));
            if (res) {
                this.cotizacion.inspeccionId = String(inspeccion.id);
                const toast = await this.toastCtrl.create({
                    message: `Cotización vinculada a la Inspección #${inspeccion.id} exitosamente`,
                    duration: 3000,
                    color: 'success',
                    position: 'bottom'
                });
                await toast.present();
            }
        } catch (e) {
            console.error('Error linking inspeccion:', e);
        }
    }

    async addTrabajoFromMenu() {
        const actionSheet = await this.actionSheetCtrl.create({
            header: 'Opciones de Trabajo',
            subHeader: `Para cotización #${this.cotizacion.id}`,
            buttons: [
                {
                    text: 'Crear Trabajo Nuevo',
                    icon: 'add-circle-outline',
                    handler: () => { this.createNewTrabajo(); }
                },
                {
                    text: 'Vincular Trabajo Existente',
                    icon: 'link-outline',
                    handler: () => { this.linkExistingTrabajo(); }
                },
                {
                    text: 'Cancelar',
                    icon: 'close',
                    role: 'cancel'
                }
            ],
            cssClass: 'custom-action-sheet'
        });
        await actionSheet.present();
    }

    async createNewTrabajo() {
        let items = [];
        try {
            const resp: any = await firstValueFrom(
                this.javapiService.getCommonModel(
                    this.metodosGenService.setModeloGeneral(
                        "cotizaciones", "cotizacionGet", String(this.cotizacion.id), '', '', '', '', '', '', '', '', '', '', '', '', '', ''
                    )
                )
            );
            if (Array.isArray(resp)) items = resp;
        } catch (e) {
            console.error('Error fetching cotizacion items:', e);
        }

        const modal = await this.modalCtrl.create({
            component: TrabajoseditComponent,
            componentProps: {
                mode: 'add',
                initialItems: items,
                // Pre-fill with cotización data
                formData: {
                    cliente: this.cotizacion.cliente || '',
                    lugar: this.cotizacion.direccion || '',
                    solicitante: this.cotizacion.solicitante || '',
                    incluyeMaterial: this.cotizacion.materiales === 'Y',
                    estado: 'No iniciado',
                    descripcion: this.cotizacion.descripcion || ''
                }
            }
        });
        await modal.present();

        const { data } = await modal.onDidDismiss();
        if (data && data.action === 'saved') {
            // New trabajo created, link it automatically
            const newTrabajoId = data.data?.id; 
            if (newTrabajoId) {
                await this.confirmLink({ id: newTrabajoId });
            }
        }
    }

    async linkExistingTrabajo() {
        const modal = await this.modalCtrl.create({
            component: TrabajoslistComponent,
            componentProps: {
                selectionMode: true,
                cotizacion: this.cotizacion
            }
        });
        await modal.present();

        const { data } = await modal.onDidDismiss();
        if (data && data.selectedTrabajo) {
            await this.confirmLink(data.selectedTrabajo);
        }
    }

    async confirmLink(trabajo: any) {
        try {
            const usuario = this.metodosGenService.getUsuario();
            const payload = this.metodosGenService.setModeloGeneral(
                "cotizaciones", "linkCotizacionTrabajo",
                String(this.cotizacion.id),
                String(trabajo.id),
                usuario, '', '', '', '', '', '', '', '', '', '', '', ''
            );

            const res: any = await firstValueFrom(this.javapiService.getCommonModel(payload));
            if (res) {
                this.cotizacion.trabajoId = trabajo.id;
                const toast = await this.toastCtrl.create({
                    message: `Cotización vinculada al Trabajo #${trabajo.id} exitosamente`,
                    duration: 3000,
                    color: 'success',
                    position: 'bottom'
                });
                await toast.present();
            }
        } catch (e) {
            console.error('Error linking trabajo:', e);
        }
    }

    async loadBillingInfo() {
        try {
            const payload = this.metodosGenService.setModeloGeneral(
                'genModel', 'factura_empresa_get_fiscal',
                String(this.cotizacion.id), '', '', '', '', '', '', '', '', '', '', '', '', '', ''
            );
            const data: any = await firstValueFrom(this.javapiService.getCommonModel(payload));
            if (Array.isArray(data) && data.length > 0) {
                const b = data[0];
                this.billingInfo = {
                    facturaFiscal: b.dt1,
                    fechaFiscal: b.dt2,
                    paquete: b.dt3,
                    fechaPago: b.dt4,
                    tipoPago: b.dt5,
                    notas: b.dt6,
                    facturaEmpresa: b.dt7,
                    fechaEmpresa: b.dt8
                };
            }
        } catch (e) {
            console.error('Error loading billing info:', e);
        }
    }

    async checkLinkedInspeccion() {
        if (!this.cotizacion?.id) return;
        // Si no viene definido o viene como '0', hacer fallback rápido
        if (!this.cotizacion.inspeccionId || this.cotizacion.inspeccionId === '0') {
            try {
                const payload = this.metodosGenService.setModeloGeneral(
                    'cotizaciones', 'cotizacionesAll', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''
                );
                const data: any = await firstValueFrom(this.javapiService.getCommonModel(payload));
                if (Array.isArray(data)) {
                    const match = data.find((row: any) => String(row.dt1) === String(this.cotizacion.id));
                    if (match && match.dt15) {
                        const parts = match.dt15.split('|');
                        const insId = parts[9];
                        if (insId && insId !== '0') {
                            this.cotizacion.inspeccionId = insId;
                        }
                    }
                }
            } catch (e) {
                console.error('Error checking linked inspeccion:', e);
            }
        }
    }
}
